import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import authAPI from "../authAPI";
import { selectAuthUserId } from "../../features/auth/AuthSlice";

export const useMySystemRoles = () => {
  const userId = useSelector(selectAuthUserId);

  return useQuery(["user", "me", "system-roles"], authAPI.getMySystemRoles, {
    enabled: !!userId,
  });
};
